import { BaseSyntheticEvent, Dispatch, SetStateAction } from "react";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { appColors } from "../../../../../theme";

const DeleteConfirmDialog = ({
  setOpenDeleteDialog,
  openDeleteDialog,
  setIsDeletionConfirmed,
  type,
}: {
  setOpenDeleteDialog: Dispatch<SetStateAction<boolean>>;
  openDeleteDialog: boolean;
  setIsDeletionConfirmed: Dispatch<SetStateAction<boolean>>;
  type: string;
}) => {
  return (
    <Dialog fullWidth={true} maxWidth={"sm"} open={openDeleteDialog}>
      <DialogTitle>
        <Typography
          fontSize={22}
          fontWeight={500}
          color={appColors.primary}
          textAlign={"left"}
        >
          Delete
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ padding: "2em" }}>
        <Box>
          <Typography variant="body1">
            Are you sure you want to remove this {type}?
          </Typography>
        </Box>
        <Box sx={{ width: "100%", display: "flex" }}>
          <Button
            onClick={() => {
              setIsDeletionConfirmed(false);
              setOpenDeleteDialog(false);
            }}
            sx={{ width: 150, marginLeft: "auto", marginTop: "1.5em" }}
          >
            No
          </Button>
          <Button
            onClick={() => {
              setIsDeletionConfirmed(true);
              setOpenDeleteDialog(false);
            }}
            sx={{ width: 150, marginLeft: ".5em", marginTop: "1.5em" }}
          >
            Yes
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmDialog;
